document.addEventListener("DOMContentLoaded", e => {
    const quickViewModal = document.querySelector(".quick-product--wrap.modal");

    if(quickViewModal) {
        const observer = new MutationObserver((mutationList, observer) => {
        mutationList.forEach(async (mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                //TODO complete functionality
                if (mutation.target?.classList?.contains('active')) {
                    const key = `aco_${Date.now()}`+`${Math.random()*10}`
                    window.wcpaInit(quickViewModal, false, false, key)
                }
            }
            });
        });
        
        observer.observe(quickViewModal, {
            attributes: true,
        });
    }
})